import React, { memo } from 'react';
import PropTypes from 'prop-types';

export const FilterGroup = memo(
  ({ title = null, className = 'text-cool-gray-10 size-20 fw-medium mb-1', children }) => {
    return (
      <fieldset>
        <legend className={className}>{title}</legend>
        {children}
      </fieldset>
    );
  }
);

FilterGroup.displayName = 'FilterGroup';

FilterGroup.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};
